import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Catch any top-level render errors and display them
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: Error | null }
> {
  constructor(props: any) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return React.createElement('div', {
        style: { padding: 32, fontFamily: 'monospace', color: 'red', fontSize: 14, whiteSpace: 'pre-wrap' }
      }, '🔴 RENDER ERROR:\n\n' + this.state.error.message + '\n\n' + this.state.error.stack);
    }
    return this.props.children;
  }
}

const rootElement = document.getElementById('root');
if (rootElement) {
  try {
    const root = createRoot(rootElement);
    root.render(
      React.createElement(ErrorBoundary, null, React.createElement(App))
    );
  } catch (e: any) {
    rootElement.innerHTML = '<div style="padding:32px;font-family:monospace;color:red;font-size:14px;white-space:pre-wrap">🔴 BOOTSTRAP ERROR:\n\n' + (e?.message || String(e)) + '\n\n' + (e?.stack || '') + '</div>';
  }
} else {
  document.body.innerHTML = '<div style="padding:32px;color:red;font-size:16px">No #root element found</div>';
}
